import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35287eb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "DrivenPass", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "header-logo",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.redirectHome && _ctx.redirectHome(...args)))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "fa-lock" }),
        _hoisted_2
      ]),
      _createVNode(_component_font_awesome_icon, {
        icon: "fa-arrow-right-from-bracket",
        class: "header-logout",
        onClick: _ctx.logUserOut
      }, null, 8, ["onClick"])
    ]),
    _createElementVNode("h3", null, _toDisplayString(_ctx.pageTitle), 1)
  ]))
}